import React from 'react';
import './pricing.css';


function Pricing() {
   return (
       <div className="pricing-page animate-page page-content sec-bottom-padding">
          <div className="content-box width-1000">
             <div className="text-align-center margin-b-60">
                <div className="title-font margin-b-30">Pricing Plans</div>
                <div className="sub-heading light-color">Start with free trial. No credit card needed. Cancel at
                   anytime.
                </div>
             </div>

             <div className="plans-separate">
                <ul className="plans separate">
                   <li>
                      <div className="price-box rubik-medium flex flex-wrap  vr-space-between">
                         <div className="">
                            <div className="sub-heading type margin-b-15">Free</div>
                            <div className="to-whom rubik-regular light-color">Individual</div>
                         </div>
                         <div className="flex align-top hr-center">
                            <div className="currency rubik-regular">$</div>
                            <div className="price">0</div>
                         </div>
                         <div className="">
                            <button className="btn green-btn">Get Started for Free</button>
                         </div>
                      </div>
                   </li>
                   <li>Upto 10 publicly shared Flos</li>
                   <li>Single user</li>
                   <li>Auto-generate one more format</li>
                   <li>Works with any web app</li>
                   <li>Quick customisation</li>
                   <li>Analytics</li>
                   <li>Shareable with link or Embed anywhere</li>
                </ul>
                <ul className="plans separate">
                   <li>
                      <div className="price-box rubik-medium flex flex-wrap  vr-space-between">
                         <div className="">
                            <div className="sub-heading type margin-b-15">Starter</div>
                            <div className="to-whom rubik-regular light-color">Perfect for Freelancers</div>
                         </div>
                         <div className="flex align-top hr-center">
                            <div className="currency rubik-regular">$</div>
                            <div className="price">30</div>
                         </div>
                         <div className="">
                            <button className="btn blue-btn">Contact us</button>
                         </div>
                      </div>
                   </li>
                   <li>Unlimited Flos</li>
                   <li>Watermark-free Flos</li>
                   <li>Advanced Analytics & Insights</li>
                   <li>Auto-generate multiple formats</li>
                </ul>
                <ul className="plans separate">
                   <li>
                      <div className="price-box rubik-medium flex flex-wrap  vr-space-between">
                         <div className="">
                            <div className="sub-heading type margin-b-15">Pro</div>
                            <div className="to-whom rubik-regular light-color">Perfect for Small Team</div>
                         </div>
                         <div className="">
                            <button className="btn blue-btn">Contact us</button>
                         </div>
                      </div>
                   </li>
                   <li>Workspace analytics</li>
                   <li>Unlimited Flos</li>
                   <li className="">SSO and whitelisted domains</li>
                   <li>Onboarding & training</li>
                   <li>Advanced integrations</li>
                </ul>
             </div>

             <div className="plans-table">
                <ul className="plans round-corner">
                   <li>
                      <div className="price-box rubik-medium flex flex-wrap  vr-space-between">
                         <div className="">
                            <div className="sub-heading type margin-b-15">Free</div>
                            <div className="to-whom rubik-regular light-color">Individual</div>
                         </div>
                         <div className="flex align-top hr-center">
                            <div className="currency rubik-regular">$</div>
                            <div className="price">0</div>
                         </div>
                         <div className="">
                            <button className="btn">Get Started for Free</button>
                         </div>
                      </div>
                   </li>
                   <li>
                      <div className="price-box rubik-medium flex flex-wrap  vr-space-between">
                         <div className="">
                            <div className="sub-heading type margin-b-15">Starter</div>
                            <div className="to-whom rubik-regular light-color">Perfect for Freelancers</div>
                         </div>
                         <div className="flex align-top hr-center">
                            <div className="currency rubik-regular">$</div>
                            <div className="price">30</div>
                         </div>
                         <div className="">
                            <button className="btn blue-btn">Contact us</button>
                         </div>
                      </div>
                   </li>
                   <li>
                      <div className="price-box rubik-medium flex flex-wrap  vr-space-between">
                         <div className="">
                            <div className="sub-heading type margin-b-15">Pro</div>
                            <div className="to-whom rubik-regular light-color">Perfect for Small Team</div>
                         </div>
                         <div className="">
                            <button className="btn blue-btn">Contact us</button>
                         </div>
                      </div>
                   </li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">Upto 10 publicly shared Flos</div></li>
                   <li><div className="content">Unlimited Flos</div></li>
                   <li><div className="content">Unlimited Flos</div></li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">Single user</div></li>
                   <li><div className="content">Watermark-free Flos</div></li>
                   <li><div className="content">SSO and whitelisted domains</div></li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">720p video export resolution</div></li>
                   <li><div className="content">Collaborate on Flos</div></li>
                   <li><div className="content">Onboarding & training</div></li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">Auto-generate one more format</div></li>
                   <li><div className="content">Advanced Analytics & Insights</div></li>
                   <li><div className="content">Workspace analytics</div></li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">Works with any web app</div></li>
                   <li><div className="content">Auto-generate multiple formats (Videos, Docs, Gifs and more)</div></li>
                   <li><div className="content">Advanced integrations</div></li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">Quick customisation</div></li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">Analytics</div></li>
                </ul>
                <ul className="plans plan-features">
                   <li><div className="content">Shareable with link or Embed anywhere</div></li>
                </ul>
             </div>




          </div>
       </div>
   )
}

export default Pricing;
